import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SourceObjectAttributeFilterData {
    sourceObjectAttributes: Array<DropdownOptionIntegerId>;
    sourceObjects: Array<DropdownOptionIntegerId>;
}
